import { NgModule } from '@angular/core';
import { DateIntervalPipe } from './date-interval.pipe';
import { SortByNumberPipe } from './sortbynumber.pipe';
import { TypeofPipe } from './typeof.pipe';
import { LocaleService } from '@app/core/i18n';
import { FilterPipe } from './filter.pipe';
import { SuperTrimPipe } from './super-trim';

const pipeDeclarations = [DateIntervalPipe, SortByNumberPipe, TypeofPipe, FilterPipe, SuperTrimPipe];

@NgModule({
  exports: pipeDeclarations,
  declarations: pipeDeclarations,
  providers: [LocaleService]
})
export class SharedPipesModule {}
